export const URL_FRIENDLY = /[^A-Za-z0-9_-]/g;
